import {Keys, StorageService} from '../service/storage.service';
import {Injectable} from '@angular/core';

@Injectable()
export class UserUtil {
    private storageService: StorageService;

    constructor(storageService: StorageService) {
        this.storageService = storageService;
    }

    public isUserRegistered(): boolean {
        return this.storageService.getObject<boolean>(Keys.IS_OTP_VERIFIED);
    }

    public isUserLoggedIn(): boolean {
        return !!this.storageService.getItem(Keys.TOKEN);
    }

    public hasAssociatedLoan(user: any): boolean {
        return user && user.loan_details.length > 0;
    }

    public isPanVerified(): boolean {
        return !!this.storageService.getItem(Keys.PAN_VERIFIED);
    }
}
